/*
 * View for modifying response properties, such as the associated content
 * and escalations
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicResponse/topicResponseProperties/template/topicResponsePropertiesTemplate.html",
], function (Marionette, TopicResponsePropertiesTemplate) {
  var TopicResponsePropertiesView = {};

  TopicResponsePropertiesView.topicResponsePropertiesView = Marionette.ItemView.extend({
    template: TopicResponsePropertiesTemplate,
    events: {
      "change select": function () {
        var optionSelected = this.$el.find("select option:selected").val();
        this.trigger("change:escalation", optionSelected);
      },
    },
    modelEvents: {
      change: "render",
    },
    onRender: function () {
      this.$el.i18n();
      this.$el
        .find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]')
        .tooltip({ delay: { show: 333, hide: 0 }, container: "body" });
      //determine if we need to show the create conversation button
      //the conversation node is not part of a conversation if it doesn't have
      //any children, or isn't a child of another node (part of a collection).
      //Also conversations must be enabled in the KB and the conversation must not be a standard response
      if (
        !this.model.get("nodeToUse").standardResponse &&
        this.model.conversations &&
        !this.model.get("reviewer") &&
        (!this.model.get("nodeToUse").decisionCol ||
          this.model.get("nodeToUse").decisionCol.length === 0) &&
        !this.model.get("nodeToUse").collection
      ) {
        this.showCreateConversationButton();
      }
    },
    showCreateConversationButton: function () {
      this.$el.find("#createConversation").removeClass("invisible");
    },
    triggers: {
      "click #createConversation": "create:conversation",
      "click #associatedContentEdit": "edit:associated:content",
      "click #deleteAssociatedContent": "delete:associated:content",
      "click a#associatedContentLink": "click:associated:content",
    },
  });

  return TopicResponsePropertiesView;
});
